export default __webpack_public_path__ + "static/media/icon1.c71a1908.svg";